import React from 'react';
import { Box, TextField, Button } from 'components/mui';
import { useKeywordForm } from 'containers/pages/keywordManagement/hooks';
import * as TY from 'containers/pages/keywordManagement/constants';
import { Keyword, KeywordFormData } from 'containers/pages/keywordManagement/types';

interface KeywordFormProps {
  mode: 'add' | 'edit';
  keyword?: Keyword | null;
  onSave: (formData: KeywordFormData, isEdit: boolean) => Promise<void>;
}

function KeywordForm({ mode, keyword, onSave }: KeywordFormProps) {
  const { state, handler } = useKeywordForm({ mode, keyword, onSave });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const form = state.keyword as any;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label="Keyword *"
        name={TY.TITLE}
        value={form[TY.TITLE] || ''}
        onChange={handler.onForm}
        error={state.valid.Title.isErr}
        helperText={state.valid.Title.errMsg || 'It will be auto capitalized'}
        fullWidth
        size="small"
      />
      <TextField
        label="Instructions"
        name={TY.INSTRUCTIONS}
        value={form[TY.INSTRUCTIONS] || ''}
        onChange={handler.onForm}
        multiline
        minRows={3}
        fullWidth
        size="small"
      />
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button variant="contained" disabled={state.canNotSave} onClick={handler.onSave}>
          {mode === 'edit' ? 'SAVE' : 'CREATE'}
        </Button>
        <Button variant="outlined" onClick={handler.onReset}>
          RESET
        </Button>
      </Box>
    </Box>
  );
}

export default KeywordForm;
